import React from "react";
import { wooCategory } from "../../lib/interfaces";
import { WooCommerce } from "../../lib/api";
import SocialIcons from "../socialIcons";
import { useQuery } from "react-query";
import { Link } from "react-router-dom";
import {
  Sheet,
  SheetClose,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "../ui/sheet";
import { MenuIcon } from "lucide-react";
import { ModeToggle } from "../themeToggle";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";
import { amadeusServices } from "../../pages/services/priceList";
import BrandsDrawer from "./brandsDrawer";
import { decodeHTML } from "../../../src/lib/utils";
export default function CategoriesDrawer({
  scrolled,
}: {
  scrolled: boolean;
}) {
  // const [showLogoHideContent, setShowLogoHideContent] =
  //   useState(true);
  const { data: categories } = useQuery(
    ["wooCategories"],
    async () => {
      const res: wooCategory[] = WooCommerce.get(
        "products/categories/?per_page=100"
      )
        .then((response: any) => {
          return response.data;
        })
        .catch((error: any) => {
          console.log(error.response.data);
        });
      return res;
    }
  );
  return (
    <Sheet aria-describedby="left drawer">
      <SheetTrigger
        name="burger menu"
        className="lg:hidden block"
      >
        <MenuIcon
          className={
            scrolled
              ? "stroke-1 h-5 w-5 mt-[1px] dark:text-neutral-100"
              : "stroke-1 text-neutral-900 dark:text-neutral-900 h-5 w-5 mt-[1px]"
          }
        />
      </SheetTrigger>
      <SheetContent
        side={"left"}
        className="outline-none flex flex-col p-5 gap-10 sm:w-[75%] w-full"
        aria-describedby="hairCare"
      >
        <SheetHeader className="mt-2">
          <SheetTitle className="flex justify-center">
            <img
              src="/logo-aaa.png"
              alt=""
              className={"dark:invert w-12"}
            />
          </SheetTitle>
        </SheetHeader>
        <SheetDescription className="hidden">
          Filter by category
        </SheetDescription>
        <div className="flex flex-col gap-10 h-5/6 overflow-scroll no-scrollbar">
          <Accordion
            type="single"
            collapsible
            className="w-full text-sm flex flex-col gap-10"
          >
            <BrandsDrawer categories={categories || []} />
            <AccordionItem
              value={"HAIR CARE"}
              key={"hair-care"}
              className={`border-b-0 data-[state=open]:border-b-0`}
            >
              <AccordionTrigger className="hover:no-underline hover:text-neutral-500 p-0 font-light">
                <SheetClose
                  asChild
                  className={`flex justify-between hover:underline cursor-pointer items-center font-montserrat w-fit`}
                >
                  <Link to={`/shop/category/17/HAIR CARE`}>
                    HAIR CARE
                  </Link>
                </SheetClose>
              </AccordionTrigger>

              <AccordionContent className="mt-5 pb-0 pl-5 text-[12px] flex flex-col gap-5">
                {categories
                  ?.filter((cat) => cat.parent === 17)
                  .map((category) => (
                    <Accordion
                      collapsible
                      key={category.id}
                      type="single"
                      className="w-full flex flex-col gap-5"
                    >
                      <AccordionItem
                        value={category.name}
                        className={`border-b-0 data-[state=open]:border-b-0`}
                      >
                        <AccordionTrigger className="hover:no-underline hover:text-neutral-500 p-0 font-light">
                          <SheetClose
                            asChild
                            className={`flex justify-between hover:underline cursor-pointer items-center font-montserrat w-fit`}
                          >
                            <Link
                              to={`/shop/category/${category.id}/${category.name}`}
                            >
                              {decodeHTML(category.name)}
                            </Link>
                          </SheetClose>
                        </AccordionTrigger>
                        <AccordionContent className="p-2 mt-3 flex flex-col gap-3">
                          {categories
                            ?.filter(
                              (sub) =>
                                sub.parent === category.id
                            )
                            .map((cat: any) => (
                              <SheetClose
                                asChild
                                key={cat.id}
                              >
                                <Link
                                  to={`/shop/hairType/${cat.id}/${cat.name}`}
                                  className="text-[12px] font-light pb-2 cursor-pointer hover:text-neutral-600"
                                >
                                  {decodeHTML(cat.name)
                                    .charAt(0)
                                    .toUpperCase() +
                                    String(
                                      decodeHTML(cat.name)
                                    )
                                      .slice(1)
                                      .toLocaleLowerCase()}
                                </Link>
                              </SheetClose>
                            ))}
                        </AccordionContent>
                      </AccordionItem>
                    </Accordion>
                  ))}
              </AccordionContent>
            </AccordionItem>
            <AccordionItem
              value={"SERVICES"}
              className="border-b-0  pb-0 data-[state=open]:border-b-0"
            >
              <AccordionTrigger className="hover:no-underline hover:text-neutral-500 p-0 font-light">
                <SheetClose asChild>
                  <Link to={`/services`}>SERVICES</Link>
                </SheetClose>
              </AccordionTrigger>

              <AccordionContent className="p-2 mt-3 flex flex-col gap-3">
                {amadeusServices?.map((service: any) => (
                  <SheetClose asChild key={service.id}>
                    <Link
                      to={`/shop/hairType/${service.id}/${service.service}`}
                      className="text-[12px] font-light  pb-2 cursor-pointer hover:text-neutral-600 "
                    >
                      {decodeHTML(service.service)
                        .charAt(0)
                        .toUpperCase() +
                        String(decodeHTML(service.service))
                          .slice(1)
                          .toLocaleLowerCase()}
                    </Link>
                  </SheetClose>
                ))}
              </AccordionContent>
            </AccordionItem>
            {/* <AccordionItem
              value={"JEWELLERY"}
              className="border-b-0  pb-0 data-[state=open]:border-b-0"
            >
              <AccordionTrigger className="hover:no-underline hover:text-neutral-500 p-0 font-light">
                <SheetClose asChild>
                  <Link
                    to={`/shop/category/373/CONDITIONERS`}
                  >
                    JEWELLERY
                  </Link>
                </SheetClose>
              </AccordionTrigger>

              <AccordionContent className="p-2 mt-3 flex flex-col gap-3 sm:max-h-[400px] max-h-[150px] min-h-[150px] overflow-scroll no-scrollbar">
                {categories
                  ?.filter((cat: any) => cat.id === 485)
                  .map((category: any) => (
                    <SheetClose asChild key={category.id}>
                      <Link
                        to={`/shop/hairType/${category.id}/${category.name}`}
                        className="text-[12px] font-light  pb-2 cursor-pointer hover:text-neutral-600 "
                      >
                        {decodeHTML(
                          category.name
                        ).toLocaleUpperCase()}
                      </Link>
                    </SheetClose>
                  ))}
              </AccordionContent> */}
            {/* </AccordionItem>
            <AccordionItem
              value={"ACCESSORIES"}
              className="border-b-0 pb-0 data-[state=open]:border-b-0 w-full"
            >
              <AccordionTrigger className="hover:no-underline hover:text-neutral-500 p-0 font-light">
                <SheetClose
                  asChild
                  className={`flex justify-between hover:underline cursor-pointer items-center font-montserrat w-fit`}
                >
                  <Link
                    to={`shop/category/505/ACCESSORIES`}
                  >
                    ACCESSORIES
                  </Link>
                </SheetClose>
              </AccordionTrigger>

              <AccordionContent className="p-2 mt-3 flex flex-col gap-3 sm:max-h-[400px] max-h-[150px] min-h-[150px] overflow-scroll no-scrollbar">
                {categories
                  ?.filter(
                    (subCategory: wooCategory) =>
                      subCategory.parent === 505
                  )
                  .map((sub) => (
                    <Link
                      key={sub.id}
                      to={`/shop/category/${sub.id}/${sub.name}`}
                      className="font-light pl-5 text-sm"
                    >
                      {decodeHTML(
                        sub.name
                      ).toLocaleUpperCase()}
                    </Link>
                  ))}
              </AccordionContent>
            </AccordionItem>
            <AccordionItem
              value={"GIFT CARDS"}
              className="border-b-0 pb-0 data-[state=open]:border-b-0"
            >
              <AccordionTrigger className="hover:no-underline hover:text-neutral-500 p-0 font-light">
                <SheetClose
                  asChild
                  className={`flex justify-between hover:underline cursor-pointer items-center font-montserrat w-fit`}
                >
                  <Link
                    to={`/shop/category/366/GIFT CARDS`}
                  >
                    GIFT CARDS
                  </Link>
                </SheetClose>
              </AccordionTrigger>
              <AccordionContent className="p-2 mt-3 flex flex-col gap-3 sm:max-h-[400px] max-h-[150px] min-h-[150px] overflow-scroll no-scrollbar">
                {categories
                  ?.filter((cat: any) => cat.id === 444)
                  .map((tag: any) => (
                    <SheetClose asChild key={tag.id}>
                      <Link
                        to={`/shop/hairType/${tag.id}/${tag.name}`}
                        className="text-[12px] font-light pb-2 cursor-pointer hover:text-neutral-600 "
                      >
                        {tag.name}
                      </Link>
                    </SheetClose>
                  ))}
              </AccordionContent>
            </AccordionItem> */}
          </Accordion>
          <Link
            key={"careers"}
            to={`/careers`}
            className="text-sm font-light"
          >
            CAREERS
          </Link>
          <Link
            key={"contact"}
            to={`/contact`}
            className="text-sm font-light"
          >
            CONTACT
          </Link>
        </div>
        <div className="relative flex justify-between items-end grow h-16 bg-white dark:bg-neutral-900">
          <ModeToggle scrolled={scrolled} drawer />

          <SocialIcons drawer />
        </div>
      </SheetContent>
    </Sheet>
  );
}
